import * as React from "react";
import { Contents } from "../../Resoures/Contents";
import { CSSTransition } from "react-transition-group";
import { Footer } from "./Component/Footer";
import { ActionMenuHeader } from "./Component/ActionMenuHeader";
import { FirmLogoStore } from "../../Stroes/Variable";
import { AddLogoAction } from "../Settings/AddLogo/Action/AddLogoAction";
import { CompanyLogo } from "../../../../Wrap/Models/Domains/Company/CompanyLogo";
import { CommonHelper } from "../../../../react-core/Helpers/CommonHelper";
import { BaseComponent } from "../../../../react-core/Html/BaseComponent";
import { UIThemeAction } from "../Settings/Action/UIThemeAction";
import { Lightbox } from "../../../../react-core/Html/Components/Lightbox";
import { UserStore } from "../../../Dashboard/Stroes/Variable";
import { UserClient } from "../../../../Wrap/Api/User/User";
import { ActionType } from "../../../../react-core/Flux/ActionType";
import { UserDispatcher } from "../../Stroes/Variable";

interface ISecuredCustomNavigationMenuOverlayProps {
    onClick: (methodName: string, parameters?: any) => void;
    mainHeader: string;
    subHeader: string;
    customNavigationVisibility: boolean;
    showBack: boolean;
    onBackClick: () => void;
    isFz: boolean;
}

interface ISecuredCustomNavigationMenuOverlayState {
    logoUrl: CompanyLogo;
    isLoading: boolean;
}
// action menu layout overlay
export class SecuredCustomNavigationMenuOverlay extends BaseComponent<
    ISecuredCustomNavigationMenuOverlayProps,
    ISecuredCustomNavigationMenuOverlayState
> {
    constructor(props: any) {
        super(props);
        this.state = { logoUrl: null, isLoading: true };
        this.subscribeToStore(FirmLogoStore, () => this.onFirmLogoStoreChange());
    }

    componentDidMount() {
        const maybeUser = UserStore.getUserInfo();

        if (!maybeUser) {
            if (UserStore.getUserInfo() || UserStore.isLoading()) {
                return;
            }
            const client = new UserClient();
            const promise = client.get();

            promise.onSuccess((result) => {
                UserDispatcher.dispatch({
                    actionType: ActionType.Success,
                    payload: result,
                });
                this.getFirmLogo();
            });

            promise.onError((err) => {});
        } else {
            this.getFirmLogo();
        }
    }

    private getFirmLogo() {
        const data = FirmLogoStore.getFirmLogoInfo();
        const isAdmin = UserStore.getUserInfo()?.IsAdmin != null ? UserStore.getUserInfo().IsAdmin : true;
        if (!data) {
            AddLogoAction.getLogo(isAdmin);
        } else {
            this.setState({ logoUrl: data, isLoading: false });
        }
    }

    private onFirmLogoStoreChange() {
        const data = FirmLogoStore.getFirmLogoInfo();
        this.setState({ logoUrl: data, isLoading: false });
    }

    private onClick(method: string) {
        this.props.onClick(method);
    }

    public render(): JSX.Element {
        const _Content = Contents;
        const logoStyle = UIThemeAction.getLogoUrl(this.state.logoUrl, true);
        return (
            <>
                {this.props.customNavigationVisibility && (
                    <Lightbox
                        cssWrapper="is-navigation-lightbox"
                        show={this.props.customNavigationVisibility}
                        onClose={() => this.onClick(_Content.Method_CloseMenu)}
                        title="Main navigation"
                    >
                        <div className="cn-overlay">
                            <div className="cno-topbar">
                                <div className="container">
                                    {!this.state.isLoading && (
                                        <a className="app-logo is-inverse" style={logoStyle}>
                                            {CommonHelper.isNullOrEmpty(this.state.logoUrl?.LocalUrl) &&
                                                CommonHelper.isNullOrEmpty(this.state.logoUrl?.UploadUrl) && (
                                                    <span className="sr-only">Abrdn Advisor platform</span>
                                                )}
                                        </a>
                                    )}
                                    <button
                                        className="custom-navigation-close"
                                        onClick={() => this.onClick(_Content.Method_CloseMenu)}
                                    >
                                        <span className="cnc-icon" aria-hidden="true"></span>
                                        <span className="cnc-label">Close menu</span>
                                    </button>
                                </div>
                            </div>
                            <div className="container ad d1">
                                <ActionMenuHeader
                                    mainHeader={this.props.mainHeader}
                                    subHeader={this.props.subHeader}
                                    isFz={this.props.isFz}
                                    onBackClick={() => this.props.onBackClick()}
                                    showBack={this.props.showBack}
                                />
                                <div role="main" className="cno-main" id="main">
                                    <CSSTransition timeout={300} className="a-slide" transitionName={"overlay-view"}>
                                        {this.props.children}
                                    </CSSTransition>
                                </div>
                                <Footer onClose={() => this.onClick(_Content.Method_CloseMenu)} />
                            </div>
                        </div>
                    </Lightbox>
                )}
            </>
        );
    }
}
